import { Skeleton, Stack } from "@mui/material"

function PageSkeleton() {
    return (
        <>
            <Stack spacing={1} className="py-10 ">
                <div className="flex items-center gap-10">
                    <Skeleton variant="circular" width={40} height={40} />
                    <div>
                        <Skeleton variant="text" sx={{ fontSize: '1rem' }} className="w-[150px] md:w-[300px] lg:w-[400px]" />
                        <Skeleton variant="text" sx={{ fontSize: '1rem' }} className="w-[200px] md:w-[400px] lg:w-[800px]" />
                    </div>
                </div>
            </Stack>
            <Stack spacing={1} className="py-10 ">
                <div className="flex items-center gap-10">
                    <Skeleton variant="circular" width={40} height={40} />
                    <div>
                        <Skeleton variant="text" sx={{ fontSize: '1rem' }} className="w-[150px] md:w-[300px] lg:w-[400px]" />
                        <Skeleton variant="text" sx={{ fontSize: '1rem' }} className="w-[200px] md:w-[400px] lg:w-[800px]" />
                    </div>
                </div>
            </Stack>
            <Stack spacing={1} className="py-10 ">
                <div className="flex items-center gap-10">
                    <Skeleton variant="circular" width={40} height={40} />
                    <div>
                        <Skeleton variant="text" sx={{ fontSize: '1rem' }} className="w-[150px] md:w-[300px] lg:w-[400px]" />
                        <Skeleton variant="text" sx={{ fontSize: '1rem' }} className="w-[200px] md:w-[400px] lg:w-[800px]" />
                    </div>
                </div>
            </Stack>
        </>
    )
}

export default PageSkeleton